import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from './ImageCarousel.module.css';


import im1 from '../assets/Carousel/image1.jpg';
import im2 from '../assets/Carousel/image2.jpg';
import im3 from '../assets/Carousel/image3.jpg';
import im4 from '../assets/Carousel/image4.jpg';
import im5 from '../assets/Carousel/image5.jpg';
import im6 from '../assets/Carousel/image6.jpg';

const ImageCarousel = () => {
    const images = [
         
        { src: im1, alt: "Muzaffarpur Branch" },
        { src: im2, alt: "Muzaffarpur Branch" },
        { src: im3, alt: "Muzaffarpur Branch" },
        { src: im4, alt: "Muzaffarpur Branch" },
        { src: im5, alt: "Muzaffarpur Branch" },
        { src: im6, alt: "Muzaffarpur Branch" },
    ];

    // Ensure we have enough slides for smooth operation
    const carouselImages = [...images, ...images];

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1500,
        pauseOnHover: true,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 640, // Mobile breakpoint
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <div className={styles.carouselWrapper}>
            <div className="max-w-[1200px] mx-auto mb-8 text-center px-4">
                <h2 className="text-indigo-600 text-sm font-bold uppercase tracking-[0.2em] mb-3">Our Centers</h2>
                <h3 className="text-3xl md:text-5xl font-bold text-gray-800 ">Glimpse of Kids Work</h3>
            </div>

            <div className="max-w-[1200px] mx-auto px-5">
                <Slider {...settings}>
                    {carouselImages.map((image, index) => (
                        <div key={index} className={styles.slideContainer}>
                            <div className={styles.slideContent}>
                                <img
                                    src={image.src}
                                    alt={image.alt}
                                    className={styles.carouselImage}
                                />
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    );
};

export default ImageCarousel;
